<template lang="pug">
    .periodPopup fasdfa sdfas df
        .back(@click="$store.commit('closePopup')")

        .events
            .list
                template(v-for="(events, year) in sorted_events")
                    .year {{year}}
                    .event(v-for="event in events" @click="$router.replace('/#history_'+event.id)")
                        .image(:style="{backgroundImage:'url('+event.icon+')'}")
                            .date {{event.date}}
                                span
                        .title(v-html="event.preview_text")
</template>

<script>
    export default {
        name: "PeriodPopup",
        props:['events'],
        computed:{
          sorted_events(){
              let sorted = {};
              this.events.forEach((el)=>{
                  if (sorted[el.year]){
                      sorted[el.year].push(el);
                  } else{
                      sorted[el.year] = [el];
                  }
              })
              return sorted;
          }
        },
    }
</script>

<style scoped lang="scss">
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_variables.scss";
    .periodPopup{
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 55;
        background: #fff;
    }
    .back{
        position: absolute;
        top: 46%;
        left: 0;
        z-index: 1;
        width: 7vw;
        height: 18vw;
        background: url(../../assets/img/button_back.png) no-repeat left top/contain;
    }
    .events{
        height: 100%;
        padding-top: 24.5vw;
        overflow: auto;
    }
    .list{
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 0 12vw 30vw;
        &:before{
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 7vw;
            bottom: 0;
            width: 3px;
            background: url(../../assets/img/period_dotts-mobile.png) repeat-y left top/100% auto;
        }

    }
    .year{
        position: relative;
        margin-bottom: 3vw;
        margin-left: -1vw;
        font-size: 10vw;
        color: $red;
        &:before, &:after{
            content: '';
            display: block;
            position: absolute;
            top: 50%;
            left: -3.7vw;
            transform: translate(-50%, -50%);
            border-radius: 50%;
        }
        &:before{
            width: 8px;
            height: 8px;
            background: $red;

        }
        &:after{
            width: 16px;
            height: 16px;
            border: 2px solid $red;
        }

    }
    .event{
        margin-bottom: 8vw;
        font-family: Pobeda, Arial;
        .image{
            position: relative;
            width: 100%;
            height: 43vw;
            margin-bottom: 1vw;
            background: no-repeat center center / cover;

        }
        .date{
            position: absolute;
            top: 44%;
            font-size: 3.5vw;
            padding: 1.2vw 4vw 0.8vw 3vw;
            color: #fff;
            background: #0d50ae;
            span, &:before, &:after{
                content: '';
                display: block;
                position: absolute;
                background: #0d50ae;
            }
            span{
                top: 0;
                bottom: 0;
                right: -2vw;
                width: 4vw;
                transform: skewX(-27deg);
            }
            &:before{
                right: 100%;
                top: 50%;
                width: 5vw;
                height: 3px;
                transform: translateY(-50%);
            }
            &:after{
                width: 10px;
                height: 10px;
                left: -5.9vw;
                top: 50%;
                transform: translateY(-50%);
                border-radius: 50%;
            }
        }
        .title{
            font-size: 5.94vw;
            line-height: 1.1;
            color: $blue;
            font-weight: bold;
        }
    }
</style>
